module.exports = __webpack_public_path__ + "img/logo.ed103584.png";